import { TextInput } from '@palmetto/palmetto-components';
import { ChangeEvent, FC } from 'react';

interface TextBoxFilterProps {
  selectedValues?: string[];
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const TextBoxFilter: FC<TextBoxFilterProps> = ({ selectedValues, handleChange }) => {
  return (
    <TextInput
      id="textBoxFilter"
      type="text"
      value={selectedValues}
      autoComplete="off"
      hideLabel
      label="Filter"
      placeholder="Enter value"
      onChange={handleChange}
      size="sm"
    />
  );
};
